import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c('label', [_vm._v(_vm._s(_vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.optionGenerator.label')))]), _c('core-codemirror', {
    attrs: {
      "value": _vm.getByKey('chartOptions.custom.optionGenerator')
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.custom.optionGenerator', $event);
      }
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "data-cy": "add-example-generator"
    },
    on: {
      "click": _vm.addExampleGenerator
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Dashboards.components.widgetChartOptionsEditor.buttons.addExampleGenerator.label')) + "\n      ")])], 1), _c(VCol, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "data-cy": "show-code-option-preview"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update:showOptionsPreview', !_vm.showOptionsPreview);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Dashboards.components.widgetChartOptionsEditor.buttons.showOptionsPreview.label')) + "\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };